import { easeOut, motion} from "framer-motion"

function FadeRightWhenVisible({ children }) {
    return (
        <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease:easeOut}}
        variants={{
          visible: { opacity: 1, x: 0},
          hidden: { opacity: 0, x: 100}
        }}
      >
        {children}
      </motion.div>
    );
  }
  export default FadeRightWhenVisible;